/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../lib/@waca/baglass/js/baglass/app/plugins/GlassPlugin',
	'react',
	'../../../lib/@waca/dashboard-common/dist/ui/react_toolbar/components/ToggleSwitch',
	'../../../api/DashboardAPI'
], function(GlassPlugin, React, ToggleSwitch, DashboardAPI) {
	return class EditToggleSwitch extends GlassPlugin {
		constructor(props) {
			super(props);
			this.itemSpec.className = 'editToggleSwitch';
			this.itemSpec.small = true;
			this.itemSpec.action = {
				apply: this.onPress.bind(this)
			};
			this.itemSpec.isChecked = this.isChecked.bind(this);
			this.myRef = React.createRef();
		}

		onPress() {
			let logger = this.glassContext.getCoreSvc('.Logger');
			let context = this.glassContext.addToOptions({
				target: {
					plugin: this
				}
			});
			return this.getController().then((controller) => {
				if(typeof controller.onPress === 'function'){
					controller.onPress(context);
				}
			}).catch((error) => {
				logger.error('failed to retrieved the actionController or invoke its method', error);
			});
		}

		isChecked () {
			return this.glassContext.currentAppView.onViewRendered().then(() => {
				const dashboard = this.glassContext.currentAppView.getCurrentContentView().getDashboardApi();
				return dashboard.getMode() === DashboardAPI.MODES.EDIT;
			});
		}

		render() {
			return (<ToggleSwitch itemSpec={this.itemSpec} ref={ toggleInstance => { this._toggleComponent  = toggleInstance; } }/>);
		}

		/**
		 *Set 'checked' status to the toggle control  
		 */
		setPressed() {
			if(this._toggleComponent && this._toggleComponent.setState){
				this._toggleComponent.setState( { 'checked': true } );
			}
		}
		/**
		 *Set 'unchecked' status to the toggle control  
		 */
		setUnpressed() {
			if(this._toggleComponent && this._toggleComponent.setState){
				this._toggleComponent.setState( { 'checked': false } );
			}
		}
	};
});
